import { combineReducers } from "redux";
import generalReducer from "./generalReducer.js";
import importReducer from "./importReducer.js";
import formReducer from "./formReducer.js";

const rootReducer = combineReducers({
  application: generalReducer,
  importData: importReducer,
  form: formReducer
});

export { rootReducer as default };
export type RootState = ReturnType<typeof rootReducer>;
